import { AppUserType } from '~/enums/permissions/_types';

export const useAppPermissions = () => {
    const { can } = usePermissions();

    const canManualSync = () => {
        return can(AppUserType.Admin);
    };

    const canShowDashboardChart = () => {
        return can(AppUserType.Admin, AppUserType.Dealer, AppUserType.Partner);
    };

    const canShowDashboardOrders = () => {
        return can(AppUserType.Admin, AppUserType.Dealer, AppUserType.Partner);
    };

    const canShowDashboardDemands = () => {
        return can(AppUserType.Customer);
    };

    const canShowOrders = () => {
        return can(AppUserType.Admin, AppUserType.Partner, AppUserType.Dealer);
    };

    const canShowDemands = () => {
        // return can(AppUserType.Admin, AppUserType.Partner, AppUserType.Dealer, AppUserType.Customer);
        return can(AppUserType.Admin, AppUserType.Dealer, AppUserType.Customer);
    };

    const canShowInvoices = () => {
        return can(AppUserType.Admin, AppUserType.Partner, AppUserType.Dealer);
    };

    const canShowServiceCalls = () => {
        return can(AppUserType.Admin, AppUserType.Partner, AppUserType.Dealer);
    };

    const canShowDocuments = () => {
        //return can(AppUserType.Admin, AppUserType.Partner, AppUserType.Dealer);
        return can(AppUserType.Admin, AppUserType.Dealer);
    };

    const canShowDeliveryLists = () => {
        return can(AppUserType.Admin, AppUserType.Partner, AppUserType.Dealer);
    };
    const canCreateDemand = () => {
        return can(AppUserType.Customer);
    };

    const canSaveDemandDraft = () => {
        return can(AppUserType.Admin, AppUserType.Customer);
    };

    const canChangeStateDemand = () => {
        return can(AppUserType.Admin, AppUserType.Partner, AppUserType.Dealer);
    };

    const canCreateOrderDemand = () => {
        return can(AppUserType.Admin, AppUserType.Partner, AppUserType.Dealer);
    };

    const canCreateOrder = () => {
        return can(AppUserType.Admin, AppUserType.Dealer, AppUserType.Partner);
    };

    const canRevertOrderToDraft = () => {
        return can(AppUserType.Admin);
    };

    const canSaveOrderDraft = () => {
        return can(AppUserType.Admin, AppUserType.Dealer, AppUserType.Partner);
    };

    const canManagePartners = () => {
        return can(AppUserType.Admin);
    };

    const canManageUsers = () => {
        return can(AppUserType.Admin, AppUserType.Partner, AppUserType.Dealer);
    };

    const canManageDocuments = () => {
        return can(AppUserType.Admin);
    };

    const canManageDials = () => {
        return can(AppUserType.Admin);
    };

    const canManageCategories = () => {
        return can(AppUserType.Admin);
    };

    const canManageApp = () => {
        return canManageDials() || canManageDocuments() || canManagePartners() || canManageUsers();
    };

    const canDeleteUser = () => {
        return can(AppUserType.Admin);
    };

    return {
        canManualSync,
        canShowDashboardChart,
        canShowDashboardDemands,
        canShowDashboardOrders,
        canCreateDemand,
        canSaveDemandDraft,
        canChangeStateDemand,
        canCreateOrderDemand,
        canCreateOrder,
        canSaveOrderDraft,
        canRevertOrderToDraft,
        canManageApp,
        canManageDials,
        canManageDocuments,
        canManagePartners,
        canManageUsers,
        canManageCategories,
        canShowOrders,
        canShowDemands,
        canShowDocuments,
        canShowInvoices,
        canShowServiceCalls,
        canShowDeliveryLists,
        canDeleteUser,
    };
};
